/* ──────────────────────────────────────────────────────────────
   ProfilePage.jsx
   “Contact-Support” now opens the mail client,
   “Regulations” opens the PubMed article in a new tab.
   ────────────────────────────────────────────────────────────── */
import React         from 'react';
import { FaUserCircle }  from 'react-icons/fa';
import { MdEmail }       from 'react-icons/md';
import { IoDocumentText } from 'react-icons/io5';

import ProfileRow   from './ProfileRow';
import logoPng      from '../../assets/truscan_logo.png';
import './ProfilePage.scss';

export default function ProfilePage() {
  /* helpers ---------------------------------------------------- */
  const contactSupport = () => {
    /* opens the user’s default mail client */
    const subject = encodeURIComponent('TRUscan.AI – Support Request');
    window.location.href = `mailto:contact@docsun.health?subject=${subject}`;
  };

  const openRegulations = () => {
    /* open PubMed article (no opener for security) */
    window.open(
      'https://pubmed.ncbi.nlm.nih.gov/38598698/',
      '_blank',
      'noopener'
    );
  };

  /* render ----------------------------------------------------- */
  return (
    <div className="profile-page">
      {/* top bar */}
      <header className="top-bar">
        <img src={logoPng} alt="logo" className="logo" />
        <FaUserCircle className="avatar" />
      </header>

      {/* action rows */}
      <div className="rows">
        <ProfileRow
          icon={<MdEmail />}
          label="Contact Support"
          onClick={contactSupport}
        />
        <ProfileRow
          icon={<IoDocumentText />}
          label="Accuracy Report"
          onClick={openRegulations}
        />
      </div>

      {/* footer */}
      <footer className="version">TRUscan.AI  v1.0</footer>
    </div>
  );
}
